import { useAppSelector } from "app/hooks";
import { MoreElements } from "components/MoreElements/MoreElements";
import { getCountries } from "reduxState/settings/settings";
import { useStyles } from "../ConditionReadOnly";

export const CountriesBox = ({
  isoCodes,
  maxVisibleConditionDataCount,
}: {
  isoCodes: string[];
  maxVisibleConditionDataCount: number;
}) => {
  const classes = useStyles();
  const countriesList = useAppSelector(getCountries);

  const selectedCountries = isoCodes.map(
    (iso) => countriesList?.find((item) => item.code === iso)?.name || iso,
  );
  return (
    <>
      {selectedCountries
        .slice(0, maxVisibleConditionDataCount)
        .map((countryName) => (
          <div key={countryName} className={classes.box}>
            {countryName}
          </div>
        ))}
      <MoreElements
        totalItemsNumber={selectedCountries.length}
        tooltipData={{
          type: "labels",
          data: selectedCountries.slice(maxVisibleConditionDataCount),
        }}
      />
    </>
  );
};
